import type { LatLng } from 'shared/lib/tracking/geo';

export function lerpLatLng(a: LatLng, b: LatLng, t: number): LatLng {
  const u = Math.min(1, Math.max(0, t));
  return {
    lat: a.lat + (b.lat - a.lat) * u,
    lng: a.lng + (b.lng - a.lng) * u,
  };
}

/** Ease-out cubic for smoother deceleration at target. */
export function easeOutCubic(t: number): number {
  const u = Math.min(1, Math.max(0, t));
  return 1 - (1 - u) ** 3;
}
